module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_64",
      "title": "64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1961")])])]), _vm._v(" "), _c('p', {
    staticClass: "LHF"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SP"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz,")]), _vm._v(" by Walter M. Miller")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The High Crusade,")]), _vm._v(" by Poul Anderson")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon,")]), _vm._v(" by Algis Budrys")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Deathworld,")]), _vm._v(" by Harry Harrison")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Venus Plus X,")]), _vm._v(" by Theodore Sturgeon")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("The 1961 Hugo Awards were held in Seacon in Seattle.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The Best Novel winner was Walter M. Miller’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(". It’s a book about a postapocalyptic order of monks who preserve knowledge of science through a new dark age and toward a new apocalypse. It’s definitely a classic and a book that has lasted—it’s in print from a major publisher, it’s in the library in French and English, and I frequently hear it mentioned in discussion. I think it’s a very worthy Hugo winner.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Harry Harrison’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Deathworld")]), _vm._v(" is the only one of the five I haven’t read. I’m not sure why I haven’t—I have read quite a bit of other Harrison and enjoyed most of it. It’s in print from a small press, Wildside. It seems to be an exciting adventure of planetary exploration. It’s in the library in French only.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Poul Anderson’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The High Crusade")]), _vm._v(" has long been a favorite of mine. It has recently been republished by Baen in a fiftieth-anniversary edition. It’s in the library in French and English.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Algis Budrys’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(" is not in print, and not in the library "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_65",
      "title": "65"
    }
  }, [_vm._v("either, so I have to conclude that it hasn’t stood the test of time. I remember it as a very pulpy adventure with people exploring an alien base on the moon—not as memorable as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Who?")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Theodore Sturgeon’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Venus Plus X")]), _vm._v(" is a thought-provoking novel about gender issues—it’s a tale of androgynes living in utopia, and if it had been published more recently, it would have won a Tiptree Award. It’s a clever, thought-provoking book that’s both weirdly ahead of its time and yet could not have been written in any other. It’s in print from Vintage, and in the library in English only.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Of the four I have read, I’d say we have three really memorable SF novels that have lasted. Do these five books show where the genre was in 1960? Yes, if the genre was half thought-provoking stories and half exciting romps on other planets—and that feels about right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What else was there that year? Again using Wikipedia’s list, I find a whole lot of things. There’s Philip K. Dick’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dr. Futurity,")]), _vm._v(" Frederik Pohl’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Drunkard’s Walk,")]), _vm._v(" Peter S. Beagle’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Fine and Private Place,")]), _vm._v(" L. Sprague de Camp’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Glory That Was,")]), _vm._v(" Nikos Kazantzakis’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Last Temptation of Christ")]), _vm._v(" (published as mainstream), Poul Anderson’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tau Zero")]), _vm._v(" (a much more serious book than "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The High Crusade")]), _vm._v("), Judith Merril’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Tomorrow People,")]), _vm._v(" John Wyndham’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Trouble with Lichen,")]), _vm._v(" Alan Garner’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Weirdstone of Brisingamen,")]), _vm._v(" and James H. Schmitz’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Agent of Vega.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It wouldn’t be hard to argue that one or two of those ought to be on the list in place of one or two of the others, but I think "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(" is the standout book of the year, in any case. So were the voters at Seacon doing a good job of picking the five best books? Not a perfect job, but a pretty good job, yes, I think so.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("THER")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ATEGORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("HORT")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" “The Longest Voyage,” by Poul Anderson ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Analog,")]), _vm._v(" December 1960)")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_66",
      "title": "66"
    }
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“The Lost Kafoozalum,” by Pauline Ashwell ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Analog,")]), _vm._v(" October 1960)")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“Need,” by Theodore Sturgeon ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Beyond")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“Open to Me, My Sister,” by Philip Jos"), _c('span', {
    staticClass: "ul_accent"
  }, [_vm._v("é")]), _vm._v(" Farmer ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("F&SF,")]), _vm._v(" May 1960)")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("Poul Anderson and Theodore Sturgeon were having good years! And there’s Pauline Ashwell again too.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RAMATIC")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RESENTATION")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Twilight Zone")]), _vm._v(" (TV series)")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Time Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Village of the Damned")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AGAZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Astounding")]), _vm._v("/"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Analog,")]), _vm._v(" edited by John W. Campbell Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Amazing Stories,")]), _vm._v(" edited by Cele Goldsmith")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("F&SF,")]), _vm._v(" edited by Robert P. Mills")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROFESSIONAL")]), _vm._v(" A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RTIST")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" Ed Emshwiller")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Virgil Finlay")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Frank Kelly Freas")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Mel Hunter")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EST")]), _vm._v(" F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ANZINE")])]), _vm._v(" "), _c('p', {
    staticClass: "UL_SPF"
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Winner:")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Who Killed Science Fiction?,")]), _vm._v(" edited by Earl Kemp")]), _vm._v(" "), _c('p', {
    staticClass: "ULF"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_67",
      "title": "67"
    }
  }, [_c('span', {
    staticClass: "ul_SC"
  }, [_vm._v("Nominees:")])])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Discord,")]), _vm._v(" edited by Redd Boggs")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fanac,")]), _vm._v(" edited by Terry Carr and Ron Ellik")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Habakkuk,")]), _vm._v(" edited by Bill Donaho")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Shangri L’Affaires,")]), _vm._v(" edited by Bjo Trimble and John Trimble")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yandro,")]), _vm._v(" edited by Robert Coulson and Juanita Coulson")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OMMENTS ON")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1961")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("9. C"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("LARK")]), _vm._v("EM"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("YERS")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(" may not be what many people read SF for—in many ways, the book is more character study than world-building—though the MacGuffin raises all the philosophical questions any book could stand—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(" lacks the SF pattern incluing, the super science is taken for granted though the Super Scientist is very well drawn. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(" doesn’t much need the skills of SF reading (no more than, say, Nevil Shute—which often isn’t SF, for all the engineering included), but perhaps the reader should be informed or perhaps deformed by some experiences. Likely the reader who couldn’t stand some other writers—David Drake or "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Starship Troopers")]), _vm._v("—wouldn’t finish "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(". Chatting with AJ about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(" and some folks from Chicago, I was amused at the author’s comment that all the characters were drawn from life—though he hadn’t yet met all of them when he wrote "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon,")]), _vm._v(" he recognized them when he did meet them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Someplace around here, I’ve already given my take on the Deathworld Trilogy—which was, I think, very much a Vietnam War–influenced tale of the nature of history and human progress in the interaction of different cultures and technology. The first book is in some part an adventure story and learning, much like the Leinstar/Jenkins Exploration Party, but also a tale of cultural interaction—maybe "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Ugly American")]), _vm._v("? The second book could be seen as not only "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Connecticut Yankee in King Arthur’s Court")]), _vm._v(" with more lasting effects but also equally tragic, and the third book is a treatise on what it really takes to do well-meaning nation-building and what it costs. More pages and so "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_68",
      "title": "68"
    }
  }, [_vm._v("demanding more time than some will give to extract the message, but a very good sugar coating on the message just the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("13. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICH")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORTON")])]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("Other potential Hugo nominees:")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“Old Hundredth,” by Brian W. Aldiss")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“Something Bright,” by Zenna Henderson")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“The Lady Who Sailed the Soul,” by Cordwainer Smith")]), _vm._v(" "), _c('p', {
    staticClass: "UL"
  }, [_vm._v("“The Voices of Time,” by J. G. Ballard")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("On balance, I’d say the actual Hugo nominee list is pretty good, but any of those listed above could surely have been added. When I first read it, I’d have eagerly endorsed the Hugo for “The Longest Voyage.” While I still like it, on rereading it a couple of years ago, it seemed diminished. “The Lost Kafoozalum” (sequel to “Unwillingly to Earth”) is plenty of fun. I don’t remember “Need” all that well, but I think it was pretty good. The Farmer has a good reputation, but I’ve never read it, and I don’t usually like Farmer as much as others do. If I were to give a Retro Hugo, it would probably be to Smith’s “The Lady Who Sailed the Soul” or Ballard’s “The Voices of Time” (that last, one of my favorite early Ballard stories).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("16. G"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARDNER")]), _vm._v(" D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OZOIS")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(" deserved its Hugo, but you’re seriously underestimating "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon,")]), _vm._v(" a book almost as influential on later work as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Canticle,")]), _vm._v(" if not more so.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For short stuff, Anderson’s “The Longest Voyage,” perhaps my favorite story by him, deserved its Hugo out of that list of finalists, although “Old Hundreth” and “The Lady Who Sailed the Soul” have their virtues too.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("18. D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AVID")]), _vm._v(" G. H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARTWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("A word or two on Harry Harrison—at that time, Harrison was very much an ambitious SF writer in the literary sense. He and Brian Aldiss were about to start the first critical journal of SF, and by four years later, he was seen as one of the four people behind the New Wave in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_69",
      "title": "69"
    }
  }, [_vm._v("the UK: Aldiss, Ballard, Harrison, Moorcock. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Deathworld")]), _vm._v(" is a good book and not a piece of pulp fiction, a harbinger of Harrison’s best work to follow in the next few years.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And if you are interested, I knew Algis Budrys fairly well, and he never got over losing the Hugo to Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("22. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICH")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORTON")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Death Machine")]), _vm._v(" was Budrys’s first choice for a title. (I think it did have at least one paperback edition under that title.) There is a nice thread in the wonderful book "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Proceedings of the Institute for Twenty-First Century Studies")]), _vm._v(" ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("PITFCS")]), _vm._v("), a fanzine for SF writers from (mostly) the early sixties, edited by Theodore Cogswell, in which Budrys and others (including Kingsley Amis) discuss "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rogue Moon")]), _vm._v(" at length, including how Budrys cut it for the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("F&SF")]), _vm._v(" publication. Several other titles are suggested, including "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Armiger")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Bend in the Driveway")]), _vm._v(" (or something, memory perhaps fails me).")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("PITFCS")]), _vm._v(" is truly a fascinating book. To hark back to the previous Hugo thread, it also includes some discussion of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Starship Troopers")]), _vm._v(". Blish (who objected to the novel in part because it was originally intended to be a juvenile) promised to write a juvenile novel of his own as a counter. The result was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mission to the Heart Stars,")]), _vm._v(" which in my opinion is one of Blish’s worst novels (and he was an unusual writer with a really wide range of quality, from excellent all the way down to unpublishably bad)—one might possibly endorse the ideas behind the Blish novel in place of those behind "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Starship Troopers,")]), _vm._v(" but the novel itself is dreadful.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "ch9-sec1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ARK")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("GES AND")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OUBT")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": W")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ALTER")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("M. M")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("ILLER")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("’")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("A C")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("ANTICLE FOR")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("EIBOWITZ")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(" is about a world that has been through a flood of fire—a nuclear war that has left survivors to grope through a new dark age. It’s set in the barbarous ruins of the United States, and it’s explicitly reminiscent of the period after the fall of Rome, when the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_70",
      "title": "70"
    }
  }, [_vm._v("Church kept learning alive. It’s a clearly cyclic history, with civilization rising and destroying itself again. You’d think this would be a terrible downer, but in fact, it’s light and funny and clever as well as moving and effective and having a message.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It treads some very strange ground—between fantasy and science fiction (the Wandering Jew wanders through), between science and religion, between faith and reason, between humor and pathos. It’s an amazing book, covering a thousand years of future history, making me laugh and making me care. It’s hard to think of anything with the same kind of scope and scale.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Walter M. Miller was an absolutely wonderful short story writer. In short form, he managed to produce a lot of poignant, memorable, clever science fiction. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(" is a fix-up of three shorter works, and he never wrote another novel. There’s a sequel of sorts, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Saint Leibowitz and the Wild Horse Woman,")]), _vm._v(" which he worked at for years and which was finished for him by Terry Bisson. Despite loving Bisson, I haven’t been able to bring myself to read it. For me, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(" is complete and perfect and doesn’t need any supplementary material, sequels or prequels or inquels.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The three sections of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Canticle for Leibowitz")]), _vm._v(" were published in SF magazines in the late fifties, and then the novel came out in 1960. The concerns about nuclear war, and the particular form of nuclear war, are very much of that time. This is a rain of fire that destroys civilization and leaves mutants but doesn’t destroy the planet—that waits for the end of the book and the final destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This is the survivable nuclear war of the fifties and sixties, the war of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Chrysalids")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Farnham’s Freehold")]), _vm._v(". But this isn’t a survivalist novel, or a mutant novel—although there are mutants. This is a novel about a monastery preserving science through a dark age. Almost all the characters are monks. The central question is that of knowledge—both the knowledge the monks preserve, hiding the books, and then copying and recopying them without comprehension, and the question of what knowledge is and what it is for. There’s the irony that Leibowitz, the sainted founder of their order, was himself Jewish, which the reader knows but the monks do not.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_71",
      "title": "71"
    }
  }, [_vm._v("There’s the Wandering Jew—and the question of whether he’s really the Wandering Jew. When I think about the book, I keep coming back to the illuminated blueprint, done in gold leaf with beautiful lettering and absolutely no idea what it is that it describes and decorates. We see three time periods of the monastery of Saint Leibowitz, and we can deduce a fourth, the foundation, from what we know and what they know. There’s a nuclear war, with awful consequences, followed by a hysterical turning on scientists, who are considered responsible, and on anyone educated—the “simpleton” movement. In response, Leibowitz and others became bookleggers and memorizers, using the church as a means of preserving science.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The story starts several generations later, when “simpleton” is a polite form of address to a stranger, like “sport” to a mutant. The first section is about Brother Francis and the canonization of Saint Leibowitz. The middle section is set at a time secular civilization is just beginning to get science organized, a new renaissance. And the third section is set just before the new apocalypse, with a few monks escaping to the stars and God’s new promise. I want to repeat: It’s delightful to read. It’s easy to forget just how much sheer fun it is. I thoroughly enjoyed it—even the perspective of the buzzards and the hungry shark.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s a surprisingly positive book. The details of the monastery are pretty good. The Catholic Church was in the process of abandoning Latin at the time he was writing, and had renounced it entirely by the time the novel was published in book form, but he has them using it. (I have no problem with this. Of course, they’d have gone back to Latin in the event of a global catastrophe. I mean, it’s obvious. I’d do the same myself.) The preservation of science and knowledge generally is very well done. I love the scientist reading a fragment of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("R.U.R.")]), _vm._v(" and deducing from it that humanity as he knew it was a created servant race of the original masters who destroyed themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There’s no dark-age direct equivalent of bookleggers, but that doesn’t matter. Theologically, though, looking at the fantasy aspects, I find it odd. To start with, there’s the Wandering Jew, who appears in the first and second parts but not in the third. In the first part, he leads "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_72",
      "title": "72"
    }
  }, [_vm._v("Brother Francis to the hidden fallout chamber. In the second, he’s known as Benjamin and claims to be Lazarus, explicitly waiting for the Second Coming. He doesn’t appear in the third part, and there’s no reference to him—has he gone to the stars? If Rachel is the Messiah, he misses her. And is she? I think we’re supposed to believe she is—and I like the weirdness of it, the science-fictionality. I don’t know that it’s orthodox Catholicism—and I gather from Wikipedia that Miller was a Catholic, and was involved in bombing Monte Cassino in WWII and then thought better of it. If this is true, he certainly made something to set against that destruction.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Teresa Nielsen Hayden says that if something contains spaceships, it’s SF, unless it contains the Holy Grail, which makes it fantasy. I don’t know whether the Wandering Jew (and potentially a new female mutant Messiah) counts as the Holy Grail or not in this context. There are spaceships, the monks are taking off in them as the new flood of fire falls at the end of the book. It doesn’t really matter whether it’s science fiction or fantasy or both. Hugo votes have never had much problem with mysticism, and they definitely noticed that this really is a brilliant book.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "ch9-sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("EALLY")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OOD")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("UN")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(": P")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OUL")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("NDERSON")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("’")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("HE")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("IGH")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_BI"
  }, [_vm._v("RUSADE")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Poul Anderson was the first science fiction writer I read once I’d discovered science fiction was a genre. (This was because I was starting in alphabetical order.) I have been fond of his work for decades, and I sometimes think that it’s possible to define all of SF as variations on themes from Poul Anderson. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The High Crusade")]), _vm._v(" is a short novel, and it’s funny and clever and it works. It’s a quick read, which is good because it’s the kind of book that’s hard to put down.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I always think of it as being in the same category as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lord Kalvan of Otherwhen")]), _vm._v(" or "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lest Darkness Fall,")]), _vm._v(" though it’s not really like that at all. The premise of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The High Crusade")]), _vm._v(" is that in 1345, just as Sir Roger de Tourneville is getting ready to go to France to fight for the king, an "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_73",
      "title": "73"
    }
  }, [_vm._v("alien spaceship lands in a little Lincolnshire village. The medieval army quickly overruns the spaceship and eventually the alien empire, by a mixture of bluff, combining medieval and futuristic tech, fast talk, and deceit, as you would, really. It may not be plausible, but it’s fun, and anyway, it’s more plausible than you might imagine. There’s a scene, for instance, when they use alien bombs in a wooden trebuchet that naturally doesn’t show up on radar.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("One of the things that’s so great about this book is the voice of Brother Parvus, a monk with a gift for languages, who is rather out of his depth. The book is his first-person chronicle of the events, and the voice is just right. The way he slowly comes to understand the alien view of the universe and reconcile it with his own worldview is lovely. At one point, he decides that the biblical “four corners of the world” actually imply a cubical universe, with lots of stars and planets in it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He teaches the alien Latin, which means it can communicate only with the clergy—but, hey, it obviously makes sense. (Latin seems to have been much on the minds of the Hugo nominees of 1961.) The best thing of all is that they lose Earth. Their first thought on capturing the spaceship is how much destruction they can do with it in France, but they are betrayed by their alien prisoner and end up on an alien planet—with no way of getting back. So it’s a secret history—humanity takes over the alien empire and imposes feudalism on the aliens, and they’re still out there. Indeed, the frame story is about people in our future discovering them to everyone’s amazement.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The medieval tech is very well done, and I’m absolutely sure Anderson knew exactly how much weight an English cavalry charge could knock down, and how much airplane skin an arrow from a longbow could pierce. The alien tech is weird. It’s 1960s tech plus FTL and force shields. The navigation notes that tell where to find Earth that get destroyed were written on paper. The spaceship had an autopilot, but no computer. This makes it much easier for the knights to figure things out—I kept thinking they’re figuring it out more easily than they could if they had our tech, which shows what a long way we’ve come since 1960. This isn’t a problem with reading the book now; it’s just how it is.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_74",
      "title": "74"
    }
  }, [_vm._v("This is a fun, fast read, and just what you want as a palate cleanser. The new Baen cover is great—it’s an illustration of the novel, and it tells you what you’re going to get, knights on horseback going after green aliens in spaceships. There’s also treachery, intrigue, and courtly love, all packed into a mere 181 pages. I’m an absolute sucker for this kind of thing, and it doesn’t get any better than this.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230f158d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter9.vue
// module id = 99
// module chunks = 0